import script from "./NewLandingPageView.vue?vue&type=script&setup=true&lang=js"
export * from "./NewLandingPageView.vue?vue&type=script&setup=true&lang=js"

import "./NewLandingPageView.vue?vue&type=style&index=0&id=6fcba623&scoped=true&lang=css"

import exportComponent from "/Users/henry/ionic/verbalchess_ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fcba623"]])

export default __exports__